import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/olx-alternativa/")({
  head: () => routeHead("/olx-alternativa/"),
  beforeLoad: () => {
    throw redirect({ href: "/ghiduri/dealer-verificat-vs-vanzator-privat", statusCode: 301, replace: true });
  },
});
